export default {
    news: 'ข่าว',
    raiders: 'ยึดครอง',
    world_view: 'โลกทัศน์',
    ugc: 'แฟน UGC',
    hot_news: 'ประเด็นร้อน',
    recommend: 'แนะนำ',
    download: 'ดาวน์โหลดทันที',
    empty_data: 'ไม่มีข้อมูลเพิ่มเติม',
    more: 'เพิ่มเติม',
    detail: 'รายละเอียด',
    collapse: 'ซ่อน',
    home_title: 'ฟอรั่ม',
    top: 'สูงสุด',


    team_simulator: 'Team Builder',
    simulator_hero: `Tap "+" to select Heroes and Relics;`,
    active_synergy_title: 'Hero Synergies',
    simulator_synergy: 'Click the synergy icon below to activate it',
    team_hero: 'Heroes',
    actived_synergy: 'Activated Hero Synergies',
    checkall_synergy: 'Activate All',
    synergy_effects: 'Hero Synergy Effects',
    tj_team: 'Other Compositions',
    query_link: 'View details',
    save_image: 'Save',
    share_image: 'Share',
    artifact: 'Relic',
    base_synergy: 'Valkyrie Synergies',
    faction_synergy: 'Faction Synergies',
    rune_synergy: 'Rune Synergies',
    hero_detail: 'Details',
    add_hero: 'Add Heroes',
    add_artifact: 'Add Relics',

    relic_synergy_title: 'Relic Synergy',
    relic_effects: 'Relic Synergy Effects',
    actived_relic_synergy: 'Activated Relic Synergies',
    relic_kind: 'Type'
}